import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICrateData } from '../../../../models/Report';

@Component({
  selector: 'app-reports-table-modal',
  templateUrl: './reports-table-modal.component.html',
  styleUrls: ['./reports-table-modal.component.scss']
})
export class ReportsTableModalComponent implements OnInit {
  @Input() items: ICrateData[];
  @Input() report;
  @Output() openPalletDetails = new EventEmitter();
  displayedColumns = [];

  constructor() { }

  ngOnInit(): void {
    const isMissingPallets = this.items.some(item => item.state === 'MISSING' || item?.inconsistency?.state === 'MISSING');
    this.displayedColumns = [
      {
        label: 'RFID Pallet',
        size: 'large',
        name: 'sku'
      },
      {
        label: 'Posição esperada',
        size: 'medium',
        name: 'description'
      },
      {
        label: 'Posição encontrada',
        size: 'medium',
        name: 'expected-qty'
      },
      {
        label: 'Nível esperado',
        size: 'small',
        name: 'expected-level'
      },
      {
        label: 'Nível encontrado',
        size: 'small',
        name: 'found-level'
      },
      {
        label: 'Status',
        size: 'medium',
        name: 'status'
      },
      this.report.state === 'AWAITING_ADMIN_APPROVAL' && isMissingPallets ?
        {
          label: this.report.state === 'AWAITING_ADMIN_APPROVAL' ? 'Remover do armazém' : '',
          size: 'small',
          name: 'action'
        } : '',
      {
        label: '',
        size: 'small',
        name: 'pallet-details'
      },
    ];
  }

  emitPalletDetails(pallet) {
    this.openPalletDetails.emit(pallet);
  }

}
